<template>
    <v-container fluid>
      <v-text-field
        class="shrink"
        v-model="preorderDetails.discount"
        :label="preorderDetails.discount + '%'"
        type="number"
        dense
        placeholder="10"
        hint="Pre-Order Discount"
        persistent-hint
        outlined
        @click="change()"
      ></v-text-field>
      <v-switch
        v-model="preorderDetails.switch"
        :label="`Show Pre-Orders vs ASAP: ${preorderDetails.switch.toString()}`"
        :change="change()"
        color="primary"
      ></v-switch>
    </v-container>
</template>

<script>
export default {
  name: 'Preorder',
  beforeMount() {
    this.change()
  },
  props: ['reset'],
  watch: {
    reset: function() {
      this.preorderDetails.discount = 0
      this.change()
    }
  },
  data: () => ({
    preorderDetails: {
      switch: false,
      discount: 0
    }
  }),
  methods: {
    change: function() {
      this.$store.dispatch('updatePreorder', this.preorderDetails);
    },
  },
};
</script>
